
import { defineComponent } from "vue";
import CountDownTimer from "@/components/CountDownTimer.vue";
import PinInput from "@/components/PinInput.vue";

export default defineComponent({
  name: "App",
  components: { PinInput, CountDownTimer },
  setup() {
    function submitCode(code: string) {
      alert('submit: ' + code);
    }

    return {
      submitCode
    }
  }
});
